define('init',['edap'], function(edap) {
    'use strict';

    // EDAP guarentees that edap.globalOptions is always a {}
    var edapOpts = edap.globalOptions;

    // Add integrations version to EDAP
    edap.integrationsVersion = '0.2.0';

    if (edapOpts.skipFlush !== true) {
        edap.trigger('edap.flush');
    }

    if (edapOpts.skipPageview !== true) {
        edap.trigger('pageview');
    }

    if (edapOpts.skipTagManager !== true) {
        edap.trigger('tagmanager.load');
    }

    if (edapOpts.skipOptimizely !== true) {
        edap.trigger('optimizely.load');
    }

    return edap;
});

